<script setup>
import { Head } from "@inertiajs/vue3";

import BlogPostCard from "@/Components/BlogPostCard.vue";
import BlogPostCardSlide from "@/Components/BlogPostCardSlide.vue";
import Search from "@/Components/LayoutItems/SearchWeb.vue";
import { router, usePage, Link } from "@inertiajs/vue3";

import { onMounted, ref, inject, computed } from "vue";
const __t = inject('__t')

const props = defineProps({
	slug: { type: String, default: null, required: false },
});


const posts = ref();
const sections = ref();
onMounted(() => {
	if (props.slug) {
		axios.get(route("api.blog.section", props.slug)).then((data) => {
			posts.value = data.data.posts.data;
			// console.log(data.data)
			// sections.value = data.data.sections;

		}).catch((error) => {
			HandleErrorAxios(error);
		})
	} else {
		axios.get(route("api.posts.index", 'post')).then((data) => {
			posts.value = data.data.posts.data;
			sections.value = data.data.sections;

		}).catch((error) => {
			HandleErrorAxios(error);
		})
	}
});
</script>
<template>

	<Head :title="__t('blog')" />

	<Head>
		<meta head-key="description" name="description" :content="__t('blogSeoDescription')" />

	</Head>
	<h1 class="w-full pb-10 mt-1 text-5xl font-bold mt-md-1 marker:text-start " v-html="__t('')"></h1>
	<v-container class="pt-12 mt-12 pt-md-24">
		<v-row>
			<v-col cols="12" md="4">

				<div class="px-4 py-4 text-black bg-white border shadow-md md:mt-0 rounded-xl dark:bg-slate-800 dark:text-white"
					style="background-image: url('/assets/patterns/pattern.webp')">
					<v-card-title class="flex items-center justify-between gap-2 mb-4 text-h5 font-weight-bold">
						<div>{{ __t('search_options') }}</div>
						<Search :label="__t('search_in_blog')" />
					</v-card-title>
					<div>
						<v-card-title v-if="sections && sections.length > 0">

							<div class="flex items-center gap-2">
								<v-icon size="16" class="">mdi-folder-outline</v-icon>
								{{ __t('categories') }}
							</div>
						</v-card-title>


						<div v-for="section in sections" :key="section.id">
							<Link :href="route('blog.section', section.slug)">
							<v-card class="p-2 px-5 mt-3">
								{{ section.title }}
							</v-card>
							</Link>

						</div>

					</div>
					<div class="flex justify-end mx-4 mt-5">
						<EmptyImage :src="'/assets/svg/41.svg'" width="100" height="100" class="w-40" />
					</div>
				</div>


			</v-col>

			<v-col cols="12" md="8">
				<v-row>
					<v-col cols="12" md="6" lg="6" v-for="(post, index) in posts" :key="post.id" data-aos="fade-up"
						:data-aos-delay="index * 50">
						<BlogPostCardSlide :title="post.title" :date="post.created_at" :img="post.photo_url"
							:slug="post.slug" class="h-100" />
					</v-col>
				</v-row>
			</v-col>
		</v-row>
	</v-container>




</template>
